/** Public pages of the site, keyed like `seo.pages` in the dictionaries. */
export const SITE_PAGES = {
	home: "/",
	businessApps: "/services/applications-metier",
	expoMigration: "/services/migration-react-native-expo",
	useCases: "/cas-usage",
	useCaseHvac: "/cas-usage/maintenance-cvc",
	useCaseQhse: "/cas-usage/cabinet-qhse",
	useCaseCleaning: "/cas-usage/controle-qualite-proprete",
	useCaseTakeover: "/cas-usage/reprise-application-react-native",
	work: "/realisations",
	questoveryCase: "/realisations/questovery",
	vaerdictCase: "/realisations/vaerdict",
	chouicCase: "/realisations/chouic",
	products: "/produits",
	about: "/a-propos",
	contact: "/contact",
} as const;

export type SitePage = keyof typeof SITE_PAGES;
